import { Card, Modal, Stack, Text } from '@mantine/core';
import React from 'react';
import GridCell from '../../../components/elements/GridCell';
import Button from '../../../components/elements/Button';
import dayjs from 'dayjs';
import { maskingNationalityId } from '../../../utils/format';
import PropTypes from 'prop-types';
import CustomerTypeList from '../../../components/fragments/CustomerTypeList';

export const RenderModalSummaryCustomer = ({
  opened = false,
  data = {},
  onClose = () => {},
  onConfirm = () => {}
}) => {
  return (
    <Modal centered onClose={onClose} opened={opened} size="lg" title="Hasil Pencarian">
      <Card mb="md" withBorder>
        <Stack>
          <GridCell data={maskingNationalityId(data?.nationalityId)} label="NIK" left={3} />
          <GridCell data={data?.customerTypes ? <CustomerTypeList customerTypes={data?.customerTypes?.map(type => ({ name: type }))} /> : '-'} label="Jenis Pelanggan" left={3} />
          <GridCell data={data?.createdAt ? dayjs(data?.createdAt).locale('id').format('DD MMMM YYYY | HH:mm') : '-'} label="Waktu Pengajuan" left={3} />
          <GridCell data={data?.blockedType === 1 ? 'Diblokir Sistem' : 'Diblokir Admin'} label="Tipe Blokir" left={3} />
        </Stack>
      </Card>
      <Button fullWidth onClick={onConfirm}>Proses Pengajuan Buka Blokir</Button>
    </Modal>
  );
};

RenderModalSummaryCustomer.propTypes = {
  data: PropTypes.object,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  opened: PropTypes.bool,
};

export const RenderModalConflict = ({
  opened = false,
  onClose = () => {}
}) => {
  return(
    <Modal centered onClose={onClose} opened={opened} styles={{
      title: {
        fontSize: 30
      }
    }} title="Proses Verifikasi Sedang Berlangsung" withCloseButton={false}>
      <Text c="#52575C" fz={18}>
        Tidak dapat melakukan verifikasi karena sedang
         dilakukan proses verifikasi  oleh verifikator.
      </Text>
      <br/>
      <Button fullWidth onClick={onClose}>Tutup</Button>
    </Modal>
  );
};

RenderModalConflict.propTypes = {
  onClose: PropTypes.func,
  opened: PropTypes.bool
};
